module.exports = __webpack_public_path__ + "static/media/06_salaredacao_mobile.d2438e9d.jpg";